import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const TableStyle = styled.table`
  /* Parent styles
  ------------------------------- */
  width: 100%;
  table-layout: fixed;

  /* Child element styles
  ------------------------------- */
  .w-none {
    flex: 0 0 none;
    max-width: none;
  }

  .w-80 {
    flex: 0 0 80px;
    max-width: 80px;
  }

  .w-100 {
    flex: 0 0 100px;
    max-width: 100px;
  }

  .w-300 {
    flex: 0 0 300px;
    max-width: 300px;
  }

  .w-150 {
    flex: 0 0 150px;
    max-width: 150px;
  }

  .w-180 {
    flex: 0 0 180px;
    max-width: 180px;
  }

  .w-200 {
    flex: 0 0 200px;
    max-width: 200px;
  }

  .w-250 {
    flex: 0 0 250px;
    max-width: 250px;
  }

  .text-center {
    justify-content: center;
  }

  .text-right {
    justify-content: end;
    text-align: right;

    input {
      justify-content: end;
      text-align: right;
    }
  }

  .actions {
    display: flex;
  }

  /* Modifiers
  ------------------------------- */
  &.fixed-header {
    z-index: 35;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    align-self: flex-start;
  }

  &.table-default {
    display: flex;
    flex-direction: column;

    .table-row {
      &:nth-child(2n) {
        .table-column {
          background-color: #ffffff;
        }
      }
    }

    td,
    th {
      min-width: 180px;
    }
  }

  &.table-fixed {
    min-width: auto;
    margin-bottom: 1rem;

    .thead {
      margin-bottom: 5px;
      background-color: transparent;
      border-radius: 12px;
      display: flex;
      text-transform: uppercase;

      .table-row {
        &::after {
          content: '';
          display: block;
          width: 8px;
          background-color: transparent;
        }
      }
    }

    .actions {
      display: flex;
      /* justify-content: center; */
    }
  }

  &.split-row-color {
    .table-row {
      .table-column {
        background-color: #ffffff;

        &.is-error {
          .input-control .input {
            border-color: ${VARIABLES.COLORS.RED_1};
          }
          .message {
            height: 20px;
            font-size: 12px;
            color: ${VARIABLES.COLORS.RED_1};
            padding-left: 14px;
          }
        }

        &.actions {
          .link {
            &:hover {
              background-color: ${VARIABLES.COLORS.GRAY_8};
            }

            &.no-hover {
              &:hover {
                background-color: transparent;
              }
            }
          }
        }
      }

      &:nth-child(2n - 1) {
        .table-column {
          background-color: #ffffff;
        }
      }

      .table-column:first-child {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
      }

      .table-column:last-child {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
      }
    }
    &.saving-type {
      margin-right: 0px !important;
    }
  }
  &.css-table-his {
    margin-right: 0 !important;
    width: 100% !important;
  }
  &.header-freeze {
    .table-row {
      &:after {
        content: '';
        display: block;
        width: 10px;
        background-color: transparent;
      }
    }

    & ~ .table {
      overflow-y: scroll;
      margin-top: 6px;
      width: calc(100% + 10px);
      margin-right: -10px;

      &.split-row-color {
        .table-row {
          &:nth-child(2n) {
            .table-column {
              background-color: #ffffff;

              &.actions {
                .link {
                  &:hover {
                    background-color: ${VARIABLES.COLORS.GRAY_8};
                  }

                  &.no-hover {
                    &:hover {
                      background-color: transparent;
                    }
                  }
                }
              }
            }
          }

          &:nth-child(2n - 1) {
            .table-column {
              background-color: white;

              &.actions {
                .link {
                  &:hover {
                    background-color: ${VARIABLES.COLORS.GRAY_1};
                  }

                  &.no-hover {
                    &:hover {
                      background-color: transparent;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  &.history {
    max-height: 40vh;
    display: flex;
    /* width: calc(100% + 10px);
    margin-right: -10px; */

    .tbody {
      width: 100%;
    }

    .table-row {
      .action {
        flex: 0 0 25%;
        text-align: left;
        justify-content: left;
      }

      .detail {
        flex: 0 0 31%;
        text-align: left;
        justify-content: left;
      }

      .action-by {
        flex: 0 0 22%;
        text-align: center;
        justify-content: center;
      }

      .create-date {
        flex: 0 0 22%;
        text-align: center;
        justify-content: center;
      }
    }

    /* &.header-freeze {
      width: 100%;
      margin-right: 0;
    } */
  }

  &.company-name {
    max-height: 350px;
    display: flex;

    .tbody {
      width: 100%;
    }
    .table-row {
      .table-column {
        height: auto;
      }

      .action {
        flex: 0 0 25%;
        text-align: left;
        justify-content: left;
      }

      .code {
        flex: 0 0 18%;
        text-align: center;
        justify-content: center;

        input {
          text-align: left;
        }
      }

      .company {
        flex: 0 0 30%;
        white-space: normal;
      }

      .address {
        flex: 0 0 42%;
        white-space: normal;
      }

      .actions {
        /* padding-left: 0; */
        justify-content: center;
      }

      .table-column.actions {
        flex: 0 0 10%;
      }
    }
  }

  &.sourcing-item {
    .tbody {
      width: 100%;
    }

    .table-row {
      .table-column {
        height: auto;
        max-height: none;
      }

      .item-name {
        flex: 0 0 19%;
        min-width: 180px;
        text-align: left;
        white-space: normal;
        word-wrap: break-word;
      }

      .item-name-event {
        flex: 0 0 24%;
        min-width: 220px;
        text-align: left;
        white-space: normal;
        word-wrap: break-word;

        .section {
          display: block;
          max-width: 300px;
        }
      }

      .description {
        flex: 0 0 20%;
        min-width: 180px;
        text-align: left;
        white-space: normal;
        word-wrap: break-word;

        .section {
          display: block;
          max-width: 300px;
        }
      }

      .quantity {
        flex: 0 0 11%;
        min-width: 130px;
        text-align: center;
        justify-content: center;
      }

      .uom {
        flex: 0 0 10%;
        min-width: 120px;
        text-align: center;
        justify-content: center;
        overflow: visible;
      }

      .price {
        flex: 0 0 23%;
        min-width: 180px;
        text-align: left;
        justify-content: flex-start;

        .section {
          margin-bottom: 5px;
        }
      }

      .actions {
        /* justify-content: center; */
        min-width: 125px;

        .add-new {
          margin-top: 5px;
        }
      }
    }

    &.compare {
      .table-row {
        .quantity {
          flex: 0 0 11%;
        }

        .uom {
          flex: 0 0 12%;
        }

        .price {
          flex: 0 0 25%;
        }
      }
    }
  }

  &.popup-sourcing {
    max-height: 300px;
    display: flex;

    .tbody {
      width: 100%;
    }
  }

  &.template-manager {
    max-height: 20vh;
    display: flex;
    /* width: calc(100% + 10px);
    margin-right: -10px; */

    .tbody {
      width: 100%;
    }

    .table-row {
      .number-order {
        flex: 0 0 24%;
        text-align: center;
        justify-content: center;
      }

      .topic {
        flex: 0 0 52%;
        text-align: left;
        justify-content: left;
        flex-wrap: wrap;
      }

      .actions {
        flex: 0 0 24%;
        text-align: center;
        justify-content: center;
        padding: 0 14px;
      }
    }

    &.data-table {
      margin-top: 0;

      .table-row {
        .table-column {
          padding: 5px 14px;
          align-items: center;
          display: flex;
        }

        .actions {
          .link {
            margin-bottom: 0;
          }

          .section {
            justify-content: center;
          }
        }
      }
    }

    /* &.header-freeze {
      width: 100%;
      margin-right: 0;
    } */
  }

  &.table-borderless {
    display: table;

    .table-row {
      display: flex;
    }

    .table-column {
      display: flex;
      flex: 1;
    }
  }

  &.contact-detail {
    display: table;
    table-layout: initial;

    .table-row {
      display: table-row;
    }

    .table-column-head {
      display: table-cell;
      background-color: white;
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      color: ${VARIABLES.COLORS.GRAY_3};
      padding: 12px 10px 10px 0;
      text-transform: initial;
    }

    .table-column {
      display: table-cell;
      height: auto;
      color: ${VARIABLES.COLORS.GRAY_3};
      padding: 12px 10px 10px 0;
      overflow: none;
      white-space: initial;
    }

    .full-name {
      max-width: 300px;
    }

    .phone {
      max-width: 200px;
    }

    .email {
      max-width: 260px;
    }

    .resend-activation-email {
      padding-left: 30px;
      max-width: 250px;
    }
  }

  &.financial-score {
    display: table;

    .table-row {
      display: table-row;

      &.sub-header {
        .table-column {
          font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
          font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
          text-align: center;
          vertical-align: middle;
        }
      }
    }

    .table-column-head {
      border-radius: 0;
      text-align: center !important;
      display: table-cell;
      height: 50px;

      &.year-detail {
        width: 25%;
      }
    }

    .table-column {
      display: table-cell;
      color: ${VARIABLES.COLORS.GRAY_3};
      padding: 8px 10px 8px;
      align-items: center;
      border-radius: 0;
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
      height: 65px;
    }

    &.earning-statement {
      .detail-list {
        width: 25%;
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
        white-space: normal;
        overflow: initial;
      }

      .year-detail {
        width: 12.5%;
        text-align: center;
      }

      .negative {
        color: ${VARIABLES.COLORS.RED_1};
      }
    }

    &.financial-statement {
      .detail-list {
        width: 25%;
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
        white-space: normal;
        overflow: initial;
      }

      .year-detail {
        width: 12.5%;
        text-align: center;
      }
      .negative {
        color: ${VARIABLES.COLORS.RED_1};
      }
    }

    &.financial-ratio {
      .table-row {
        &.sub-header {
          .table-column {
            text-align: left;
            font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
            padding-left: 15px;
          }
        }
      }

      .number {
        width: 25%;
        text-align: center;
      }

      .ratio {
        width: 51%;
        text-align: center;
        text-align: left;
      }

      .year-detail {
        width: 8%;
        text-align: center;
      }

      .negative {
        color: ${VARIABLES.COLORS.RED_1};
      }
    }
  }

  &.banner {
    .table-row {
      .table-column {
        height: 90px;
        padding-top: 33px;

        &.active {
          padding-top: 38px;
        }

        &.actions {
          padding-top: 29px;
        }

        &.image {
          padding: 15px 14px;
        }
      }

      .table-column-head {
        &.image {
          padding-left: 50px;
        }
      }

      .number-order {
        flex: 0 0 7%;
        justify-content: center;
        text-align: center;
      }

      & > .image {
        flex: 0 0 14%;

        .image-control {
          width: 120px;
          height: 60px;
          overflow: hidden;
        }
      }

      .url {
        flex: 0 0 27%;

        .link {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }

      .active {
        justify-content: center;
      }

      & > .active {
        flex: 0 0 12%;
      }
    }
  }

  &.service-category-table {
    max-width: 1025px;
    width: auto;
    margin-top: 20px;

    .table-row {
      display: table-row;

      .table-column {
        display: table-cell;
        padding: 9px 20px 20px;
        background-color: ${VARIABLES.COLORS.GRAY_7};
        height: auto;
        vertical-align: top;
        border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_11};

        .checkbox-list {
          .checkbox {
            margin-bottom: 8px;
            margin-right: 0;

            .fake-label {
              color: ${VARIABLES.COLORS.BLUE_1};
              white-space: normal;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        &.business-group {
          flex: 0 0 265px;
          width: 265px;
          min-width: 265px;
          white-space: normal;
        }

        &.service-product {
          flex: 1 1 auto;
        }
      }

      .table-column-head {
        display: table-cell;
      }

      &.header {
        .table-column {
          height: 45px;
          background-color: ${VARIABLES.COLORS.GRAY_6};
          padding: 9px 20px;
        }
      }
    }
  }

  &.theme-pink {
    border: 1px solid ${VARIABLES.COLORS.RED_2};

    .table-column-head {
      background-color: ${VARIABLES.COLORS.RED_2};
      text-align: center;
      color: white;
      border: 1px solid ${VARIABLES.COLORS.RED_2};
    }

    .table-column {
      border: 1px solid ${VARIABLES.COLORS.RED_2};
    }

    .table-row {
      &:nth-child(2n) {
        .table-column {
          background-color: ${VARIABLES.COLORS.RED_OVERLAY_1};
        }
      }
    }
  }

  &.theme-blue {
    border: 1px solid ${VARIABLES.COLORS.BLUE_6};

    .table-column-head {
      background-color: ${VARIABLES.COLORS.BLUE_6};
      text-align: center;
      color: white;
      border: 1px solid ${VARIABLES.COLORS.BLUE_6};
    }

    .table-column {
      border: 1px solid ${VARIABLES.COLORS.BLUE_6};
    }

    .table-row {
      &:nth-child(2n) {
        .table-column {
          background-color: ${VARIABLES.COLORS.BLUE_7};
        }
      }
    }
  }

  &.theme-green {
    border: 1px solid ${VARIABLES.COLORS.GREEN_4};

    .table-column-head {
      background-color: ${VARIABLES.COLORS.GREEN_4};
      text-align: center;
      color: white;
      border: 1px solid ${VARIABLES.COLORS.GREEN_4};
    }

    .table-column {
      border: 1px solid ${VARIABLES.COLORS.GREEN_4};
    }

    .table-row {
      &:nth-child(2n) {
        .table-column {
          background-color: ${VARIABLES.COLORS.GREEN_6};
        }
      }
    }
  }

  /* State
  ------------------------------- */
  &.header-fixed {
    .is-error {
      .input {
        border-color: ${VARIABLES.COLORS.RED_1};
      }
    }

    .message {
      height: 20px;
      font-size: 12px;
      color: ${VARIABLES.COLORS.RED_1};
    }
  }

  &.is-scrollbar {
    .tbody {
      overflow-x: hidden;
      overflow-y: scroll;
    }
  }

  /* For noolek when merge srm to dev plz delete it!!!!
  ------------------------------- */
  /* .table-row {
    &:nth-child(2n) {
      .table-column {
        background-color: ${VARIABLES.COLORS.GRAY_7};
      }
    }
  } */

  .w-100 {
    flex: 0 0 100px;
    max-width: 100px;
  }

  .w-150 {
    flex: 0 0 150px;
    max-width: 150px;
  }

  .w-180 {
    flex: 0 0 180px;
    max-width: 180px;
  }

  .w-200 {
    flex: 0 0 250px;
    max-width: 250px;
  }

  .w-250 {
    flex: 0 0 250px;
    max-width: 250px;
  }

  .text-center {
    justify-content: center;
  }

  .actions {
    display: flex;
    /* padding: 11px 8px 9px; */

    > .section {
      margin-left: -3px;
      margin-right: -3px;
      column-gap: 5px;
    }
  }

  &.table-default,
  &.table-supplier {
    display: flex;
    flex-direction: column;

    .table-row {
      &:nth-child(2n) {
        .table-column {
          background-color: #ffffff;
        }
      }
    }

    td,
    th {
      min-width: 180px;
    }

    .actions {
      /* padding: 8px 14px; */

      & > .section {
        /* justify-content: center; */
        /* align-items: center; */
      }
    }

    .tbody {
      .table-column {
        cursor: default;
        width: auto; 
        min-height: 65px;
        height: auto;
        background-color: ${VARIABLES.COLORS.WHITE};
        /* padding: 16px 14px 8px; */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #1f2937;
        flex: 1;
      }
    }

    .thead {
      .table-column-head {
        cursor: default;
        width: auto;
        font-weight: 600;
        color: #94a3b8;
        height: 40px;
        background-color: transparent;
        padding: 0 14px;
        display: flex;
        align-items: center;
        line-height: 1.2;
        flex: 1;
        white-space: break-spaces;
      }
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    &.financial-score {
      .table-row {
        &.sub-header {
          .table-column {
            font-size: 14px;
          }
        }
      }

      .table-column-head {
        height: 48px;
      }

      .table-column {
        padding: 7px 9px 7px;
        font-size: 14px;
        height: 63px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    &.financial-score {
      .table-row {
        &.sub-header {
          .table-column {
            font-size: 13px;
          }
        }
      }

      .table-column-head {
        height: 46px;
      }

      .table-column {
        padding: 6px 8px 6px;
        font-size: 13px;
        height: 60px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    &.header-freeze {
      & ~ .table {
        width: calc(100% + 5px);
        margin-right: -5px;
      }
    }

    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &.financial-score {
      .table-row {
        &.sub-header {
          .table-column {
            font-size: 12px;
          }
        }
      }

      .table-column-head {
        height: 46px;
      }

      .table-column {
        padding: 5px 7px;
        font-size: 12px;
        height: 56px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    &.financial-score {
      .table-row {
        &.sub-header {
          .table-column {
            font-size: 11px;
          }
        }
      }

      .table-column-head {
        height: 44px;
      }

      .table-column {
        padding: 5px;
        font-size: 11px;
        height: 51px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    &.financial-score {
      .table-row {
        &.sub-header {
          .table-column {
            font-size: 10px;
          }
        }
      }

      .table-column-head {
        height: 40px;
      }

      .table-column {
        padding: 5px;
        font-size: 10px;
        height: 46px;
      }
    }
  }
`

export const TableRowStyle = styled.tr`
  /* Parent styles
  ------------------------------- */
  width: 100%;
  display: flex;

  /* Child element styles
  ------------------------------- */
  .tax-id {
    flex: 0 0 12%;
    min-width: 135px;
  }

  .requestunseal_date {
    flex: 0 0 10%;
    min-width: 20px;
  }

  .requestunseal_fullname {
    flex: 0 0 45%;
    min-width: 135px;
  }

  .requestunseal_email {
    flex: 0 0 45%;
    min-width: 135px;
  }

  .requestunseal_phone {
    flex: 0 0 33.33%;
    min-width: 135px;
  }

  .requestunseal_date_init {
    flex: 0 0 20%;
    min-width: 135px;
    text-transform: uppercase;
  }

  .requestunseal_fullname_init {
    flex: 0 0 20%;
    min-width: 135px;
    text-transform: uppercase;
  }

  .requestunseal_fullname_body {
    flex: 0 0 20%;
    min-width: 135px;
  }

  .requestunseal_email_init {
    flex: 0 0 20%;
    min-width: 135px;
    text-transform: uppercase;
  }

  .requestunseal_email_body {
    flex: 0 0 20%;
    min-width: 135px;
  }

  .requestunseal_phone_init {
    flex: 0 0 20%;
    min-width: 135px;
    text-transform: uppercase;
  }

  .requestunseal_phone_body {
    flex: 0 0 20%;
    min-width: 135px;
  }

  .requestunseal_action_init {
    flex: 0 0 20%;
    min-width: 135px;
    text-transform: uppercase;
  }

  .company-name {
    min-width: 300px;
    flex: 1 1 auto;
  }

  .name {
    flex: 0 0 13%;
    min-width: 170px;
  }

  .email {
    flex: 0 0 13%;
    min-width: 170px;
  }

  .phone {
    flex: 0 0 10%;
    min-width: 160px;
  }

  .status {
    flex: 0 0 7%;
    min-width: 110px;
    text-align: center;
    justify-content: center;
  }

  .created-date {
    flex: 0 0 15%;
    text-align: center;
    justify-content: center;
  }

  .last-update {
    flex: 0 0 16%;
    min-width: 200px;
    text-align: center;
    justify-content: center;
  }

  .actions {
    /* flex: 0 0 10%; */
    /* text-align: center;
    justify-content: center; */
  }

  .no {
    flex: 0 0 7%;
    text-align: center;
    justify-content: center;
  }

  .contact-name {
    flex: 0 0 16%;
    text-align: center;
    justify-content: center;
  }

  .branch-number {
    flex: 0 0 11%;
    justify-content: center;
    text-align: center;
  }

  .vendor-code {
    flex: 0 0 11%;
    justify-content: center;
    text-align: center;
  }

  /* Modifiers
  ------------------------------- */
  /* &.header {
    .actions {
      padding: 9px 2.8% 10px 2.8%;
    }
  } */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
  }

  @media all and (max-width: 1366.98px) {
    /* & > .table-column {
      min-width: 0 !important;
    } */
  }

  @media all and (max-width: 1280.98px) {
  }

  @media all and (max-width: 1024.98px) {
  }
`

export const TableColumnStyle = styled.td`
  /* Parent styles
  ------------------------------- */
  cursor: default;
  width: auto; 
  min-height: 65px;
  //height: 65px;
  height: auto;
  background-color: ${VARIABLES.COLORS.WHITE};
  padding: 14px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  flex: 1;
  /* flex: 1 1 0; */

  &.role {
    /* text-overflow: inherit;
    overflow: auto;
    white-space: break-spaces; */
  }
  &.selected-qty-td {
    input#selected-qty {
      text-align: center;
    }
  }
  &.selected-qty-td {
    input#selected-qty-err {
      text-align: center;
      border-color: red;
    }
  }
  /* Child element styles
  ------------------------------- */
  p {
    &.completed-status {
      color: ${VARIABLES.COLORS.GREEN_1};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.requested-status {
      color: ${VARIABLES.COLORS.YELLOW_2};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.incomplete-status {
      color: ${VARIABLES.COLORS.GRAY_5};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.not-registered-status {
      color: ${VARIABLES.COLORS.GRAY_5};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.apporved-status {
      color: ${VARIABLES.COLORS.GREEN_1};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.rejected-status {
      color: ${VARIABLES.COLORS.RED_3};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.wait-for-approval-status {
      color: ${VARIABLES.COLORS.YELLOW_2};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.wait-for-activate-status {
      color: ${VARIABLES.COLORS.YELLOW_2};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.wait-status {
      color: ${VARIABLES.COLORS.YELLOW_2};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
    }

    &.active-status {
      color: ${VARIABLES.COLORS.GREEN_1};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.seal-status {
      color: ${VARIABLES.COLORS.GREEN_1};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    /* start status color */
    &.success-status {
      color: ${VARIABLES.COLORS.GREEN_1};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.info-status {
      color: ${VARIABLES.COLORS.GRAY_5};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.rejected-status {
      color: ${VARIABLES.COLORS.RED_3};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.pending-status {
      color: ${VARIABLES.COLORS.YELLOW_2};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }
    /* end status color */

    &.inactive-status {
      color: ${VARIABLES.COLORS.GRAY_5};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    /* &.inactive-status {
      color: ${VARIABLES.COLORS.GRAY_5};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    } */

    &.wait-active-status {
      color: ${VARIABLES.COLORS.YELLOW_2};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }

    &.draft-status {
      color: ${VARIABLES.COLORS.YELLOW_2};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }
    &.seal-status-awaiting {
      color: ${VARIABLES.COLORS.YELLOW_2};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }
    &.seal-status-unsealed {
      color: ${VARIABLES.COLORS.GREEN_1};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }
    &.seal-status-sealed {
      color: ${VARIABLES.COLORS.GRAY_5};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: capitalize;
    }
  }

  p[class*='status'] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: 20px;
    margin: 0;
    padding: 0 8px;
    border-radius: 999px;
    background-color: #f1f2f8;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    text-transform: capitalize;
  }

  p.active-status,
  p.success-status,
  p.completed-status,
  p.apporved-status,
  p.seal-status,
  p.seal-status-unsealed {
    background-color: #e6faf7;
    color: #0f8a7a;
  }

  p.rejected-status,
  p.wrong-status {
    background-color: rgba(226, 65, 50, 0.12);
    color: #e24132;
  }

  p.pending-status,
  p.wait-status,
  p.requested-status,
  p.wait-for-approval-status,
  p.wait-for-activate-status,
  p.wait-active-status,
  p.draft-status,
  p.seal-status-awaiting {
    background-color: #e0f4ff;
    color: #3d6fd8;
  }

  .wrong-status {
    color: ${VARIABLES.COLORS.RED_3};
    text-transform: capitalize;
    display: inline;

    .wrong-icon {
      display: inline-flex;
      margin-left: 5px;
    }
  }

  a {
    &.link {
      text-decoration: underline;
      color: ${VARIABLES.COLORS.BLUE_2};
      margin-bottom: 10px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        color: ${VARIABLES.COLORS.BLUE_1};
      }
    }
  }

  /* Modifiers
  ------------------------------- */
  &:first-child {
    border-top-left-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    border-bottom-left-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
  }

  &:last-child {
    border-top-right-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    border-bottom-right-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
  }

  &.actions {
    /* padding: 14px 0 0 2.5%; */

    .link {
      width: 31px;
      flex: 0 0 31px;
      height: 31px;
      display: flex;
      /* margin: 0 3px 5px; */

      .image-control {
        &.edit-icon {
          width: 18px;
        }

        &.history-icon {
          width: 19px;
        }

        &.delete-icon {
          width: 15px;
        }

        &.export-icon {
          width: 19px;
        }

        &.delete-circle-icon {
          width: 16px;
        }

        &.compare-icon {
          width: 27px;
        }

        &.paste-icon {
          width: 15px;
        }

        &.download-icon {
          width: 27px;
        }

        &.cursor-icon {
          width: 18px;
        }
      }

      &:hover {
        background-color: ${VARIABLES.COLORS.GRAY_1};
      }

      &.no-hover {
        &:hover {
          background-color: transparent;
        }
      }
    }

    & > .section {
      /* justify-content: center;
      align-items: center; */
    }
  }

  /* State
  ------------------------------- */
  &.is-error {
    .input {
      border-color: ${VARIABLES.COLORS.RED_1};
    }

    .select__control {
      border-color: ${VARIABLES.COLORS.RED_1};
    }

    .message {
      margin-top: 5px;
      margin-bottom: 10px;
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
      color: ${VARIABLES.COLORS.RED_1};
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 6400px){
    /* max-height: inherit; */
  }
  @media all and (max-width: 1600.98px) {
    min-height: 62px;
    /* padding: 17px 14px 15px; */

    &.actions {
      .link {
        width: 29px;
        flex: 0 0 29px;
        height: 29px;
        /* margin: 0 3px 5px; */

        .image-control {
          &.edit-icon {
            width: 17px;
          }

          &.history-icon {
            width: 18px;
          }

          &.delete-icon {
            width: 14px;
          }

          &.export-icon {
            width: 18px;
          }

          &.delete-circle-icon {
            width: 15px;
          }

          &.compare-icon {
            width: 25px;
          }

          &.paste-icon {
            width: 14px;
          }

          &.download-icon {
            width: 25px;
          }

          &.cursor-icon {
            width: 17px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    min-height: 52px;
    /* padding: 15px 12px 13px; */

    &.actions {
      .link {
        width: 27px;
        flex: 0 0 27px;
        height: 27px;
        /* margin: 0 3px 4px; */

        .image-control {
          &.edit-icon {
            width: 16px;
          }

          &.history-icon {
            width: 17px;
          }

          &.delete-icon {
            width: 13px;
          }

          &.export-icon {
            width: 17px;
          }

          &.delete-circle-icon {
            width: 14px;
          }

          &.compare-icon {
            width: 23px;
          }

          &.paste-icon {
            width: 13px;
          }

          &.download-icon {
            width: 23px;
          }

          &.cursor-icon {
            width: 16px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    min-height: 48px;
    /* padding: 13px 10px 11px; */

    &.actions {
      .link {
        width: 25px;
        flex: 0 0 25px;
        height: 25px;
        /* margin: 0 2px 3px; */

        .image-control {
          &.edit-icon {
            width: 15px;
          }

          &.history-icon {
            width: 16px;
          }

          &.delete-icon {
            width: 12px;
          }

          &.export-icon {
            width: 16px;
          }

          &.delete-circle-icon {
            width: 13px;
          }

          &.compare-icon {
            width: 22px;
          }

          &.paste-icon {
            width: 12px;
          }

          &.download-icon {
            width: 22px;
          }

          &.cursor-icon {
            width: 15px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    min-height: 42px;
    /* padding: 11px 8px 9px; */

    &.actions {
      .link {
        width: 23px;
        flex: 0 0 23px;
        height: 23px;
        /* margin: 0 2px 3px; */

        .image-control {
          &.edit-icon {
            width: 14px;
          }

          &.history-icon {
            width: 15px;
          }

          &.delete-icon {
            width: 11px;
          }

          &.export-icon {
            width: 15px;
          }

          &.delete-circle-icon {
            width: 12px;
          }

          &.compare-icon {
            width: 20px;
          }

          &.paste-icon {
            width: 11px;
          }

          &.download-icon {
            width: 20px;
          }

          &.cursor-icon {
            width: 14px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    min-height: 35px;
    /* padding: 8px 6px; */

    &.actions {
      .link {
        width: 20px;
        flex: 0 0 20px;
        height: 20px;

        .image-control {
          &.edit-icon {
            width: 13px;
          }

          &.history-icon {
            width: 14px;
          }

          &.delete-icon {
            width: 10px;
          }

          &.export-icon {
            width: 14px;
          }

          &.delete-circle-icon {
            width: 11px;
          }

          &.compare-icon {
            width: 18px;
          }

          &.paste-icon {
            width: 10px;
          }

          &.download-icon {
            width: 18px;
          }

          &.cursor-icon {
            width: 13px;
          }
        }
      }
    }
  }

`

export const TableColumnHeadStyle = styled.th`
  /* Parent styles
  ------------------------------- */
  cursor: default;
  width: auto;
  font-weight: 600;
  color: #94a3b8;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  height: 40px;
  background-color: transparent;
  padding: 0 16px;
  display: flex;
  align-items: center;
  line-height: 1.2;
  flex: 1;
  /* min-width: 180px; */

  /* Child element styles
  ------------------------------- */
  .sort-icon {
    width: 11px;
    margin-left: 6px;
    transition: ${VARIABLES.TRANSITIONS.FAST} all;
    transform: translateY(0) rotate(180deg);
  }

  /* Modifiers
  ------------------------------- */
  &:first-child {
    border-top-left-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    border-bottom-left-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
  }

  &:last-child {
    border-top-right-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    border-bottom-right-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
  }

  /* State
  ------------------------------- */
  &.is-sortable {
    cursor: pointer;

    &.is-desc {
      .sort-icon {
        transform: translateY(0);
      }
    }

    &.is-asc {
      .sort-icon {
        transform: translateY(0) rotate(180deg);
      }
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    height: 43px;
    /* padding: 0 12px; */

    .sort-icon {
      width: 10px;
      margin-left: 5px;
    }
  }

  @media all and (max-width: 1440.98px) {
    min-height: 41px;
    height: auto;
    /* padding: 3px 11px; */

    .sort-icon {
      width: 9px;
    }
  }

  @media all and (max-width: 1366.98px) {
    min-height: 40px;
    /* padding: 3px 10px; */

    .sort-icon {
      width: 8px;
      margin-left: 4px;
    }
  }

  @media all and (max-width: 1280.98px) {
    min-height: 39px;
    /* padding: 3px 8px; */

    .sort-icon {
      width: 7px;
    }
  }

  @media all and (max-width: 1024.98px) {
    min-height: 38px;
    /* padding: 2px 5px; */
  }
`

export const TBodyStyle = styled.tbody`
  display: block;

  .table-row {
    margin-bottom: 8px;
    border-radius: 12px;
    overflow: hidden;
    background-color: #ffffff;
    box-shadow: 0 2px 8px rgba(31, 41, 55, 0.04);
  }

  .table-row:hover {
    box-shadow: 0 8px 16px rgba(108, 99, 255, 0.16);
  }
`

export const THeadStyle = styled.thead`
  display: block;

  .table-row {
    margin-bottom: 4px;
    background-color: transparent;
    box-shadow: none;
  }

  .table-column-head {
    background-color: transparent;
    color: #94a3b8;
  }
`

export const TFootStyle = styled.tfoot``
